import { Link } from "react-router-dom";
import type { Plot } from "@/mocks/plots";

interface PlotCardProps {
  plot: Plot;
  layout?: "vertical" | "horizontal";
}

export default function PlotCard({ plot, layout = "vertical" }: PlotCardProps) {
  if (layout === "horizontal") {
    return (
      <Link
        to={`/detail/plot/${plot.id}`}
        className="group flex gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
      >
        <div className="relative h-24 w-36 shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-28 sm:w-44">
          <img
            src={plot.thumbnail}
            alt={plot.title}
            title={`年轻的母亲1 剧情解析 ${plot.title}`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col">
          <div className="mb-1.5 flex flex-wrap gap-1.5">
            {plot.tags.slice(0, 2).map((tag) => (
              <span key={tag} className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                {tag}
              </span>
            ))}
          </div>
          <h3 className="line-clamp-2 text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
            {plot.title}
          </h3>
          <p className="mt-1.5 line-clamp-2 hidden text-xs leading-relaxed text-foreground-600 sm:block">
            {plot.excerpt}
          </p>
          <div className="mt-auto flex items-center gap-3 pt-2 text-[11px] text-foreground-500">
            <span>
              <i className="ri-calendar-line mr-1" />
              {plot.date}
            </span>
            <span>
              <i className="ri-time-line mr-1" />
              {plot.readTime}
            </span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/detail/plot/${plot.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative w-full aspect-video overflow-hidden bg-background-200">
        <img
          src={plot.thumbnail}
          alt={plot.title}
          title={`年轻的母亲1 剧情解析 ${plot.title}`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-full bg-accent-500/95 px-2 py-0.5 text-[11px] font-medium text-background-50">
          {plot.tags[0]}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="line-clamp-2 text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
          {plot.title}
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{plot.excerpt}</p>
        <div className="mt-3 flex items-center justify-between border-t border-background-100 pt-3 text-xs text-foreground-500">
          <span>
            <i className="ri-user-line mr-1" />
            {plot.author}
          </span>
          <span>
            <i className="ri-time-line mr-1" />
            {plot.readTime}
          </span>
        </div>
      </div>
    </Link>
  );
}